import React from "react";
import {FormattedMessage, useIntl} from "react-intl";

import {createTheme} from "@mui/material/styles";

import BoldTitle from "views/quote/components/show/notes/components/NoteBlock/BoldTitle";
import Header from "views/quote/components/show/notes/components/NoteBlock/Header";
import LastNoteContent from "views/quote/components/show/notes/components/NoteBlock/LastNoteContent";
import NoteBlock from "views/quote/components/show/notes/components/NoteBlock";
import NoteCardContent from "views/quote/components/show/notes/components/NoteBlock/NoteCardContent";
import NoteCardActions from "views/quote/components/show/notes/components/NoteBlock/NoteCardActions";
import HistoryNotes from "views/quote/components/show/notes/components/HistoryNotes";
import HistoryNoteDetail from "views/quote/components/show/notes/components/HistoryNotes/HistoryNoteDetail";

import {ORDER_INTERNAL_NOTE} from "views/quote/enums/quoteNoteType";
import {greenColor} from "assets/jss/main";

const internalNoteTheme = createTheme({
    palette: {primary: {main: greenColor}},
});

function InternalNote({items, order}) {
    const intl = useIntl();

    if (!items || items.length === 0) return null;

    const lastNote = items[0];
    const historyNotes = items.slice(1);

    const user = lastNote.member?.user;
    const userName = user
        ? `${user.givenName} ${user.familyName}`
        : intl.formatMessage({id: "picking.order.show.note.customer"});

    const centerContent = (
        <div style={{fontWeight: 400}}>
            <BoldTitle>{userName}</BoldTitle>&nbsp;
            <FormattedMessage id="picking.order.show.note.internalNote.action" />
        </div>
    );

    const noteLabel = intl.formatMessage({id: 'picking.quote.history.internalNote'});

    return (
        <NoteBlock theme={internalNoteTheme}>
            <NoteCardContent>
                <Header
                    title={`${noteLabel} ${items.length}`}
                    subtitle={order?.externalId?.toString() || ''}
                    date={lastNote.createdAt}
                    centerContent={centerContent}
                    noteType={ORDER_INTERNAL_NOTE}
                />
                <LastNoteContent content={lastNote.content} />
            </NoteCardContent>
            {historyNotes.length > 0 && (
                <NoteCardActions>
                    <HistoryNotes noteType={ORDER_INTERNAL_NOTE}>
                        {historyNotes.map((note, index) => {
                            const userGivenName = note.member.user.givenName
                            const userFamilyName = note.member.user.familyName
                            let userFullName = null

                            if (userFamilyName && userGivenName) {
                                userFullName = `${userGivenName} ${userFamilyName}`
                            }
                            return (
                                <HistoryNoteDetail
                                    key={index}
                                    date={note.createdAt}
                                    subtitle={note.member?.user?.fullName || userFullName || note.member?.user?.email}
                                    title={`${noteLabel} ${historyNotes.length - index}`}
                                    content={note.content}
                                />
                            )
                        })}
                    </HistoryNotes>
                </NoteCardActions>
            )}
        </NoteBlock>
    );
}

export default InternalNote;
